import React from "react";
import "./ContentWrapper.scss";
import classNames from "classnames";
export interface StepProps {
    children: React.ReactNode;
    className?: string;
}
const ContentWrapper = ({ children, className }: StepProps) => {
    return (
        <div
            className={classNames("subject-choice-content-wrapper", className)}
        >
            {children}
        </div>
    );
};

export default ContentWrapper;
